export default "__VITE_ASSET__DfujlxVN__"